import React from "react";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { ProfileNavigation } from "@common/profileNavigation";
import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { RestrictedArea } from "@scenes/restrictedArea";
import { usePlanzonePermissions } from "@components/permissions";
import { Props } from "./types";
import { ProjectPage } from "./projectPage";
import { StrategicAxesPage } from "./strategicAxesPage";
import { ProjectReportTemplatePage } from "./projectReportTemplatePage";
import { ProjectModelsPage } from "./projectModelsPage";
import { SecondaryCriteriaTemplatePage } from "./secondaryCriteriaTemplatePage";
import styles from "./styles.scss";

function UtilityPage(_: Props) {
  const { t } = useTranslation();
  const { isAdministrator } = usePlanzonePermissions();
  const { pathname } = useLocation();
  const pagesTitles: { [id: string]: string } = {
    "/utilities": t("utilityPage.navigation.projects"),
    "/utilities/reports": t("utilityPage.navigation.projectReportTemplate"),
  };

  return (
    <WorkspaceContext type="planzone">
      <div className={styles.utilityPage}>
        <div className={styles.header}>
          <h1 className={styles.title}>{pagesTitles[pathname]}</h1>
          <div className={styles.profileNavigation}>
            <AssistantShortcut />
            <Notifications />
            <ProfileNavigation />
          </div>
        </div>
        <div className={styles.main}>
          <div className={styles.content}>
            <RestrictedArea
              areas={[
                "projectStatuses",
                "projectReportsTemplate",
                "projectTemplates",
                "secondaryCriteriaTemplate",
                "strategicAxes",
              ]}
            >
              {({
                canAccessProjectReportsTemplate,
                canAccessProjectTemplates,
                canAccessProjectStatuses,
                canAccessSecondaryCriteriaTemplate,
                canAccessStrategicAxes,
              }) => (
                <Routes>
                  {canAccessProjectReportsTemplate && (
                    <Route
                      path="/reports"
                      element={<ProjectReportTemplatePage />}
                    />
                  )}
                  {canAccessProjectTemplates && (
                    <Route
                      path="/project-models"
                      element={<ProjectModelsPage />}
                    />
                  )}
                  {canAccessStrategicAxes && (
                    <Route
                      path="/strategic-axes"
                      element={<StrategicAxesPage />}
                    />
                  )}
                  {canAccessSecondaryCriteriaTemplate && (
                    <Route
                      path="/criteria"
                      element={<SecondaryCriteriaTemplatePage />}
                    />
                  )}
                  {canAccessProjectStatuses && (
                    <Route path="/" element={<ProjectPage />} />
                  )}
                </Routes>
              )}
            </RestrictedArea>
          </div>
        </div>
      </div>
    </WorkspaceContext>
  );
}

export { UtilityPage };
